import { AttachmentCategory, type AttachmentSelectDto, AttachmentType } from '@@types/api.types';
import { sortTechnologyImages } from '@components/pages/technology/components/technology-images.utils';

export type TechnologyAttachmentEditorKind = AttachmentType | 'IMAGE';

export const TECHNOLOGY_ATTACHMENT_EDITOR_IMAGE_KIND = 'IMAGE' as const;

export const getTechnologyAttachmentEditorKind = (
  attachment: Pick<AttachmentSelectDto, 'category' | 'type'>,
): TechnologyAttachmentEditorKind => {
  return attachment.category === AttachmentCategory.TECHNOLOGY_IMAGE
    ? TECHNOLOGY_ATTACHMENT_EDITOR_IMAGE_KIND
    : attachment.type;
};

export const getTechnologyAttachmentList = (params: {
  generalAttachments: AttachmentSelectDto[];
  technologyImages: AttachmentSelectDto[];
}): AttachmentSelectDto[] => {
  const { generalAttachments, technologyImages } = params;

  const sortedImages = sortTechnologyImages(technologyImages);

  const sortedGeneralAttachments = [...generalAttachments].sort((firstAttachment, secondAttachment) => {
    return new Date(secondAttachment.createdAt).getTime() - new Date(firstAttachment.createdAt).getTime();
  });

  return [...sortedImages, ...sortedGeneralAttachments];
};

export const isTechnologyAttachmentEditorKind = (kind: string): kind is TechnologyAttachmentEditorKind => {
  return (
    kind === AttachmentType.FILE || kind === AttachmentType.URL || kind === TECHNOLOGY_ATTACHMENT_EDITOR_IMAGE_KIND
  );
};

export const isTechnologyAttachmentImageKind = (kind: TechnologyAttachmentEditorKind): kind is 'IMAGE' => {
  return kind === TECHNOLOGY_ATTACHMENT_EDITOR_IMAGE_KIND;
};
